<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-input v-model="userId" placeholder="用户ID"/>
            </el-form-item>
            <el-form-item>
                <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始时间"
                                end-placeholder="结束时间" value-format="timestamp"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryAnalysis()">查询</el-button>
            </el-form-item>
            <el-form-item label="风险等级">
                <span :style="{color: riskLevel === 'HIGH' ? 'red' : 'green'}">{{riskLevel}}</span>
            </el-form-item>
        </el-form>

        <el-table :data="balanceDiffList | filterList">
            <el-table-column label="币种" prop="coinType"/>
            <el-table-column label="可用" prop="avChange"/>
            <el-table-column label="冻结" prop="frChange"/>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="lookInfo(scope.row.coinType)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="详情" :visible.sync="look" @close="look = false">
            <el-table :data="coinBalanceChange">
                <el-table-column label="币种" prop="coinType"/>
                <el-table-column label="类型" prop="businessType"/>
                <el-table-column label="钱包类型">
                    <template slot-scope="scope">{{parseDesc(scope.row.walletType,walletTypes)}}</template>
                </el-table-column>
                <el-table-column label="可用" prop="avChange"/>
                <el-table-column label="冻结" prop="frChange"/>
                <el-table-column label="时间">
                    <template slot-scope="scope">{{scope.row.businessTime | moment}}</template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import api from "../api";

    export default {
        name: "BalanceAnalysis",
        data() {
            return {
                userId: '',
                time: [],
                balanceDiffList: [],
                coinBalanceChangeMap: {},
                riskLevel: '',
                walletTypes: [{code: 'WALLET', desc: '现货账户'}, {code: 'MARGIN', desc: '杠杆账户'}, {
                    code: 'OTC',
                    desc: '法币账户'
                }, {code: 'CONTRACT', desc: '合约账户'}, {code: 'GENERAL', desc: '超级合约'}],
                coinBalanceChange: [],
                look: false,
            }
        },
        methods: {
            queryAnalysis() {
                let data = {
                    userId: this.userId
                };
                if (this.time) {
                    data.start = this.time[0];
                    data.end = this.time[1];
                }
                api.userBalanceAnalysis(data).then(response => {
                    this.riskLevel = response.data.riskLevel;
                    this.balanceDiffList = response.data.balanceDiffList;
                    this.coinBalanceChangeMap = response.data.coinBalanceChangeMap;
                })
            },
            lookInfo(coinType) {
                this.coinBalanceChange = [];
                for (let key in this.coinBalanceChangeMap) {
                    if (key === coinType) {
                        this.coinBalanceChange = this.coinBalanceChangeMap[key];
                        this.look = true;
                        return;
                    }
                }
                this.$message.error('当前无数据');
            },
            parseDesc(code, list) {
                for (let i in list) {
                    if (code === list[i].code) {
                        return list[i].desc;
                    }
                }
            }
        },

        filters: {
            filterList: (value) => {
                return value.filter(item => item.avChange !== 0 || (item.frChange !== 0 && item.frChange !== null));
            }
        }
    }
</script>

<style scoped>

</style>
